import { writable } from 'svelte/store';
import { demoSetupStoreKey, userProgressStoreKey, loginStoreKey } from './constants';
import { authSvc } from './services/auth.service';
import { demoSvc } from './services/demo.service';

export const contents = writable();
export const currentContent = writable();
export const currentPopup = writable(false);

export const chapters = writable();
export const chapterNav = writable([]);
export const currentChapter = writable();
export const chapterSwitched = writable();

export const questions = writable();
export const currentQuestion = writable();
export const userIsApproved = writable(false);
export const userProfile = writable();
export const examProgress = writable();

const clubData = window.golfclub;

const demoData = demoSvc.getDemoStoreOrDefault(demoSetupStoreKey, null, 'localStorage');
if (demoSvc.isDemoInstance() && demoData) {
  window.golfclub.title = demoData.name;
}
export const club = writable(clubData);

// demo setup state
export const demoSetup = writable(demoData);
if (demoSvc.isDemoInstance()) {
  console.log('BE/GOLF DEMO INSTANCE');
  demoSetup.subscribe(data => {
    localStorage.setItem(demoSetupStoreKey, JSON.stringify(data));
  });
}

// Loggedin state
const loggedInData = demoSvc.isDemoInstance() ? demoSvc.getDemoStoreOrDefault(loginStoreKey, false) : null;
export const loggedIn = writable(loggedInData);
if (demoSvc.isDemoInstance()) {
loggedIn.subscribe(status => {
    sessionStorage.setItem(loginStoreKey, JSON.stringify(status));
  });
} else {
  authSvc.verifyAuthData();
}

// userProgress store must be located before currentChapter store
let userProgressStore;
const userProgressData = demoSvc.getDemoStoreOrDefault(userProgressStoreKey, {});
export const userProgress = writable(userProgressData);
userProgress.subscribe(up => {
  if (Object.keys(up).length) {
    userProgressStore = up;
    if (demoSvc.isDemoInstance()) {
      sessionStorage.setItem(userProgressStoreKey, JSON.stringify(up));
    }
  }
});
